!(function (e, t) {
  'object' == typeof exports && 'undefined' != typeof module
    ? (module.exports = t())
    : 'function' == typeof define && define.amd
      ? define(t)
      : ((e.ReactIntlLocaleData = e.ReactIntlLocaleData || {}), (e.ReactIntlLocaleData.mn = t()));
})(this, function () {
  'use strict';
  return [
    {
      locale: 'mn',
      pluralRuleFunction: function (e, t) {
        return t ? 'other' : 1 == e ? 'one' : 'other';
      },
      fields: {
        year: {
          displayName: 'жил',
          relative: { 0: 'энэ жил', 1: 'ирэх жил', '-1': 'өнгөрсөн жил' },
          relativeTime: {
            future: { one: '{0} жилийн дараа', other: '{0} жилийн дараа' },
            past: { one: '{0} жилийн өмнө', other: '{0} жилийн өмнө' }
          }
        },
        'year-short': {
          displayName: 'жил',
          relative: { 0: 'энэ жил', 1: 'ирэх жил', '-1': 'өнгөрсөн жил' },
          relativeTime: {
            future: { one: '{0} жилийн дараа', other: '{0} жилийн дараа' },
            past: { one: '{0} жилийн өмнө', other: '{0} жилийн өмнө' }
          }
        },
        month: {
          displayName: 'сар',
          relative: { 0: 'энэ сар', 1: 'ирэх сар', '-1': 'өнгөрсөн сар' },
          relativeTime: {
            future: { one: '{0} сарын дараа', other: '{0} сарын дараа' },
            past: { one: '{0} сарын өмнө', other: '{0} сарын өмнө' }
          }
        },
        'month-short': {
          displayName: 'сар',
          relative: { 0: 'энэ сар', 1: 'ирэх сар', '-1': 'өнгөрсөн сар' },
          relativeTime: {
            future: { one: '{0} сарын дараа', other: '{0} сарын дараа' },
            past: { one: '{0} сарын өмнө', other: '{0} сарын өмнө' }
          }
        },
        day: {
          displayName: 'өдөр',
          relative: { 0: 'өнөөдөр', 1: 'маргааш', 2: 'нөгөөдөр', '-2': 'уржигдар', '-1': 'өчигдөр' },
          relativeTime: {
            future: { one: '{0} өдрийн дараа', other: '{0} өдрийн дараа' },
            past: { one: '{0} өдрийн өмнө', other: '{0} өдрийн өмнө' }
          }
        },
        'day-short': {
          displayName: 'өдөр',
          relative: { 0: 'өнөөдөр', 1: 'маргааш', 2: 'нөгөөдөр', '-2': 'уржигдар', '-1': 'өчигдөр' },
          relativeTime: {
            future: { one: '{0} өдрийн дараа', other: '{0} өдрийн дараа' },
            past: { one: '{0} өдрийн өмнө', other: '{0} өдрийн өмнө' }
          }
        },
        hour: {
          displayName: 'цаг',
          relative: { 0: 'энэ цаг' },
          relativeTime: {
            future: { one: '{0} цагийн дараа', other: '{0} цагийн дараа' },
            past: { one: '{0} цагийн өмнө', other: '{0} цагийн өмнө' }
          }
        },
        'hour-short': {
          displayName: 'ц',
          relative: { 0: 'энэ цаг' },
          relativeTime: {
            future: { one: '{0} ц дараа', other: '{0} ц дараа' },
            past: { one: '{0} ц өмнө', other: '{0} ц өмнө' }
          }
        },
        minute: {
          displayName: 'минут',
          relative: { 0: 'энэ минут' },
          relativeTime: {
            future: { one: '{0} минутын дараа', other: '{0} минутын дараа' },
            past: { one: '{0} минутын өмнө', other: '{0} минутын өмнө' }
          }
        },
        'minute-short': {
          displayName: 'мин',
          relative: { 0: 'энэ минут' },
          relativeTime: {
            future: { one: '{0} мин дараа', other: '{0} мин дараа' },
            past: { one: '{0} мин өмнө', other: '{0} мин өмнө' }
          }
        },
        second: {
          displayName: 'секунд',
          relative: { 0: 'одоо' },
          relativeTime: {
            future: { one: '{0} секундын дараа', other: '{0} секундын дараа' },
            past: { one: '{0} секундын өмнө', other: '{0} секундын өмнө' }
          }
        },
        'second-short': {
          displayName: 'сек',
          relative: { 0: 'одоо' },
          relativeTime: {
            future: { one: '{0} сек дараа', other: '{0} сек дараа' },
            past: { one: '{0} сек өмнө', other: '{0} сек өмнө' }
          }
        }
      }
    },
    {
      locale: 'mn-Mong',
      pluralRuleFunction: function (e, t) {
        return 'other';
      },
      fields: {
        year: {
          displayName: 'Year',
          relative: { 0: 'this year', 1: 'next year', '-1': 'last year' },
          relativeTime: { future: { other: '+{0} y' }, past: { other: '-{0} y' } }
        },
        'year-short': {
          displayName: 'Year',
          relative: { 0: 'this year', 1: 'next year', '-1': 'last year' },
          relativeTime: { future: { other: '+{0} y' }, past: { other: '-{0} y' } }
        },
        month: {
          displayName: 'Month',
          relative: { 0: 'this month', 1: 'next month', '-1': 'last month' },
          relativeTime: { future: { other: '+{0} m' }, past: { other: '-{0} m' } }
        },
        'month-short': {
          displayName: 'Month',
          relative: { 0: 'this month', 1: 'next month', '-1': 'last month' },
          relativeTime: { future: { other: '+{0} m' }, past: { other: '-{0} m' } }
        },
        day: {
          displayName: 'Day',
          relative: { 0: 'today', 1: 'tomorrow', '-1': 'yesterday' },
          relativeTime: { future: { other: '+{0} d' }, past: { other: '-{0} d' } }
        },
        'day-short': {
          displayName: 'Day',
          relative: { 0: 'today', 1: 'tomorrow', '-1': 'yesterday' },
          relativeTime: { future: { other: '+{0} d' }, past: { other: '-{0} d' } }
        },
        hour: {
          displayName: 'Hour',
          relative: { 0: 'this hour' },
          relativeTime: { future: { other: '+{0} h' }, past: { other: '-{0} h' } }
        },
        'hour-short': {
          displayName: 'Hour',
          relative: { 0: 'this hour' },
          relativeTime: { future: { other: '+{0} h' }, past: { other: '-{0} h' } }
        },
        minute: {
          displayName: 'Minute',
          relative: { 0: 'this minute' },
          relativeTime: { future: { other: '+{0} min' }, past: { other: '-{0} min' } }
        },
        'minute-short': {
          displayName: 'Minute',
          relative: { 0: 'this minute' },
          relativeTime: { future: { other: '+{0} min' }, past: { other: '-{0} min' } }
        },
        second: {
          displayName: 'Second',
          relative: { 0: 'now' },
          relativeTime: { future: { other: '+{0} s' }, past: { other: '-{0} s' } }
        },
        'second-short': {
          displayName: 'Second',
          relative: { 0: 'now' },
          relativeTime: { future: { other: '+{0} s' }, past: { other: '-{0} s' } }
        }
      }
    }
  ];
});
